/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProfileKgoose} from '../api'

 export const useQueryGetProfileKgoose = createReactQueryHook('getProfileKgoose', getProfileKgoose)
